import {
  AbbviePharmacyTable,
  AmgenPharmacyTable,
  AstellasPharmacyTable,
  AstrazenecaPharmacyTable,
  BauschNLombPharmacyTable,
  BayerPharmacyTable,
  BiPharmacyTable,
  BiogenPharmacyTable,
  BmsPharmacyTable,
  CytokineticsPharmacyTable,
  EisaiPharmacyTable,
  EliLillyPharmacyTable,
  EmdSeronoPharmacyTable,
  ExelixisPharmacyTable,
  GenentechPharmacyTable,
  GskPharmacyTable,
  IncytePharmacyTable,
  JazzPharmacyTable,
  JnJPharmacyTable,
  LeoPharmacyTable,
  LiquidiaPharmacyTable,
  MerckPharmacyTable,
  NovartisPharmacyTable,
  NovoNordiskPharmacyTable,
  PfizerPharmacyTable,
  SandozPharmacyTable,
  SanofiPharmacyTable,
  ShionogiPharmacyTable,
  SobiPharmacyTable,
  StemlinePharmacyTable,
  SumitomoPharmacyTable,
  TakedaPharmacyTable,
  TevaPharmacyTable,
  UcbPharmacyTable,
  VertexPharmacyTable,
  ViatrisPharmacyTable,
  AllPharmaciesTable as AllPharmacyTable,
} from "./PharmacyTables";
import {
  AbbvieDesignationsForm,
  AmgenDesignationsForm,
  AstellasDesignationsForm,
  AstrazenecaDesignationsForm,
  BauschNLombDesignationsForm,
  BayerDesignationsForm,
  BiDesignationsForm,
  BiogenDesignationsForm,
  BmsDesignationsForm,
  CytokineticsDesignationsForm,
  EisaiDesignationsForm,
  EliLillyDesignationsForm,
  EmdSeronoDesignationsForm,
  ExelixisDesignationsForm,
  GenentechDesignationsForm,
  GskDesignationsForm,
  IncyteDesignationsForm,
  JazzDesignationsForm,
  JnjDesignationsForm,
  LeoDesignationsForm,
  LiquidiaDesignationsForm,
  MerckDesignationsForm,
  NovartisDesignationsForm,
  NovoNordiskDesignationsForm,
  PfizerDesignationsForm,
  SandozDesignationsForm,
  SanofiDesignationsForm,
  ShionogiDesignationsForm,
  SobiDesignationsForm,
  StemlineDesignationsForm,
  SumitomoDesignationsForm,
  TakedaDesignationsForm,
  TevaDesignationsForm,
  UcbDesignationsForm,
  VertexDesignationsForm,
  ViatrisDesignationsForm,
} from "./DesignationForms";

export default function getManufacturerComponents(manufacturer, props) {
  const componentMapping = {
    all: {
      PharmacyTable: AllPharmacyTable,
      DesignationsForm: null,
      additionalProps: {
        claims_count: props.claims_count,
        mfr_designations: props.mfr_designations,
        eligibility: props.eligibility,
      },
    },
    abbvie: {
      PharmacyTable: AbbviePharmacyTable,
      DesignationsForm: AbbvieDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.abbvie,
      },
    },
    amgen: {
      PharmacyTable: AmgenPharmacyTable,
      DesignationsForm: AmgenDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.amgen,
      },
    },
    astellas: {
      PharmacyTable: AstellasPharmacyTable,
      DesignationsForm: AstellasDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.astellas,
      },
    },
    astrazeneca: {
      PharmacyTable: AstrazenecaPharmacyTable,
      DesignationsForm: AstrazenecaDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.astrazeneca,
      },
    },
    bausch_n_lomb: {
      PharmacyTable: BauschNLombPharmacyTable,
      DesignationsForm: BauschNLombDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.bausch_n_lomb,
        submitPath: props.attestationSubmitPath,
      },
    },
    bayer: {
      PharmacyTable: BayerPharmacyTable,
      DesignationsForm: BayerDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.bayer,
      },
    },
    biogen: {
      PharmacyTable: BiogenPharmacyTable,
      DesignationsForm: BiogenDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.biogen,
        submitPath: props.attestationSubmitPath,
      },
    },
    boehringer_ingelheim: {
      PharmacyTable: BiPharmacyTable,
      DesignationsForm: BiDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.boehringer_ingelheim,
      },
    },
    bristol_myers_squibb: {
      PharmacyTable: BmsPharmacyTable,
      DesignationsForm: BmsDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.bristol_myers_squibb,
      },
    },
    cytokinetics: {
      PharmacyTable: CytokineticsPharmacyTable,
      DesignationsForm: CytokineticsDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.cytokinetics,
      },
    },
    eisai: {
      PharmacyTable: EisaiPharmacyTable,
      DesignationsForm: EisaiDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.eisai,
        submitPath: props.attestationSubmitPath,
      },
    },
    eli_lilly: {
      PharmacyTable: EliLillyPharmacyTable,
      DesignationsForm: EliLillyDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.eli_lilly,
      },
    },
    emd_serono: {
      PharmacyTable: EmdSeronoPharmacyTable,
      DesignationsForm: EmdSeronoDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.emd_serono,
      },
    },
    exelixis: {
      PharmacyTable: ExelixisPharmacyTable,
      DesignationsForm: ExelixisDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.exelixis,
      },
    },
    genentech: {
      PharmacyTable: GenentechPharmacyTable,
      DesignationsForm: GenentechDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.genentech,
      },
    },
    glaxosmithkline: {
      PharmacyTable: GskPharmacyTable,
      DesignationsForm: GskDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.glaxosmithkline,
        submitPath: props.attestationSubmitPath,
      },
    },
    incyte: {
      PharmacyTable: IncytePharmacyTable,
      DesignationsForm: IncyteDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.incyte,
        submitPath: props.attestationSubmitPath,
      },
    },
    jazz: {
      PharmacyTable: JazzPharmacyTable,
      DesignationsForm: JazzDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.jazz,
        submitPath: props.attestationSubmitPath,
      },
    },
    johnson_n_johnson: {
      PharmacyTable: JnJPharmacyTable,
      DesignationsForm: JnjDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.johnson_n_johnson,
        geoJson: props.geo_json,
      },
    },
    leo: {
      PharmacyTable: LeoPharmacyTable,
      DesignationsForm: LeoDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.leo,
      },
    },
    liquidia: {
      PharmacyTable: LiquidiaPharmacyTable,
      DesignationsForm: LiquidiaDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.liquidia,
      },
    },
    merck: {
      PharmacyTable: MerckPharmacyTable,
      DesignationsForm: MerckDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.merck,
      },
    },
    novartis: {
      PharmacyTable: NovartisPharmacyTable,
      DesignationsForm: NovartisDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.novartis,
        submitPath: props.attestationSubmitPath,
      },
    },
    novo_nordisk: {
      PharmacyTable: NovoNordiskPharmacyTable,
      DesignationsForm: NovoNordiskDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.novo_nordisk,
        submitPath: props.attestationSubmitPath,
      },
    },
    pfizer: {
      PharmacyTable: PfizerPharmacyTable,
      DesignationsForm: PfizerDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.pfizer,
      },
    },
    sanofi: {
      PharmacyTable: SanofiPharmacyTable,
      DesignationsForm: SanofiDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.sanofi,
        submitPath: props.attestationSubmitPath,
      },
    },
    sandoz: {
      PharmacyTable: SandozPharmacyTable,
      DesignationsForm: SandozDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.sandoz,
        submitPath: props.attestationSubmitPath,
      },
    },
    mtpa: {
      PharmacyTable: ShionogiPharmacyTable,
      DesignationsForm: ShionogiDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.mtpa,
        submitPath: props.attestationSubmitPath,
      },
    },
    sobi: {
      PharmacyTable: SobiPharmacyTable,
      DesignationsForm: SobiDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.sobi,
      },
    },
    stemline: {
      PharmacyTable: StemlinePharmacyTable,
      DesignationsForm: StemlineDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.stemline,
      },
    },
    sumitomo: {
      PharmacyTable: SumitomoPharmacyTable,
      DesignationsForm: SumitomoDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.sumitomo,
      },
    },
    takeda: {
      PharmacyTable: TakedaPharmacyTable,
      DesignationsForm: TakedaDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.takeda,
        submitPath: props.attestationSubmitPath,
      },
    },
    teva: {
      PharmacyTable: TevaPharmacyTable,
      DesignationsForm: TevaDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.teva,
        submitPath: props.attestationSubmitPath,
      },
    },
    ucb: {
      PharmacyTable: UcbPharmacyTable,
      DesignationsForm: UcbDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.ucb,
      },
    },
    vertex: {
      PharmacyTable: VertexPharmacyTable,
      DesignationsForm: VertexDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.vertex,
      },
    },
    viatris: {
      PharmacyTable: ViatrisPharmacyTable,
      DesignationsForm: ViatrisDesignationsForm,
      additionalProps: {
        eligibility: props.eligibility.viatris,
      },
    },
  };

  return componentMapping[manufacturer];
}
